<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <material-card
      v-if="dialog"
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Employee Disciplines"
      text="Remove Employee Disciplines"
      class="mb-0"
    >
      <v-card-text> Are you sure you want to remove this disciplinary case? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"        
          @click="submitForm"
        >
          Remove
        </v-btn>
      </v-card-actions>
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        disciplinaryCase: {},
      }
    },
    methods: {
      toggleDialog (disciplinaryCase) {
        this.disciplinaryCase = { ...disciplinaryCase }

        this.dialog = true
      },
      submitForm () {
        this.progressing = true

        this.$api.employeeDisciplineCases().delete(this.disciplinaryCase.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
            this.dialog = false
          })
      },
    },
  }
</script>
